import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import moment from "moment/moment";
import {useController, useForm} from "react-hook-form";
import axios from "../../../../helpers/axios";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import CustomDatePicker from "../../../base/components/forms/customDatePicker";
import FormHookInput from "../components/formHookInput";
import LoadingButton from "../../../base/components/loadingButton";
import FormHookSelect from "../components/formHookSelect";
import {Form, Tab, Tabs} from "react-bootstrap";
import {Table} from "reactstrap";
import numberFormat from "../../../../helpers/numberFormat";
import BlockUi from "@availity/block-ui";
import _ from "lodash"
import {Link} from "react-router-dom";
import Tooltip from "../../../../helpers/ToolTip";
import SearchSelect from "../../../../components/searchSelect";
import TiedUpPaymentsInfo from "../components/tiedUpPaymentsInfo";

const sortingFields = [
  {label:'Дата выписки', value:'issueDateValue'},
  {label:'Дата вылета', value:'flightDateValue'}
]
const status = [
  {value:null, label: "Все"},
  {value:"paid", label: "Оплаченые"},
  {value:"unpaid", label: "Не оплаченные"},
  {value:"needToCheck", label: "На проверке"},
]

const TiedUpList = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const [selectedIds, setSelectedIds] = useState([])
  const [pageTab, setPageTab] = useState("ties")
  const [tabIndex, setTabIndex] = useState(window.location.hash?.slice(1) ||"list");
  const [emplArray, setEmplArray] = useState()

  const defaultVal ={
    start: moment().subtract(1, 'months').format('DD.MM.YYYY'),
    end: moment().format('DD.MM.YYYY'),
    issuedBy: null,
    sortField: 'flightDateValue',
    needToCheck: false,
    status: null
  }
  const formController = useForm(defaultVal)
  const {register,
    getValues,
    control,
    handleSubmit,
    formState:{errors}} = formController

  const {
    field: { onChange: issuedByOnChange, value: issuedByValue }
  } = useController({
    name: "issuedBy",
    control,
    defaultValue: null
  });
  const {
    field: { onChange: statusOnChange, value: statusValue }
  } = useController({
    name: "status",
    control,
    defaultValue: null
  });

  const loadInfo = (data) =>{
    setLoading(true)
    Object.keys(data).map(key=>{
      if(data[key] === null){
        delete data[key]
      }
    })
    axios.post('/api/air/airBooking/tiedUpTickets/list', {query: data})
      .then(({data})=>{
        setData(data.tickets)
        setSelectedIds([])
      })
      .finally(setLoading.bind(false))
  }
  const onSubmit = (data) =>{
    loadInfo(data)
  }

  const clickToggle = (field,id) =>{
    setLoading(true)
    axios.post('/api/air/airBooking/tiedUpTickets/toggle/'+id,{field})
      .then(()=>{
        loadInfo(getValues())
      })
      .finally(setLoading.bind(false))
  }

  const toggleSelected = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(itemId => itemId !== id) : [...prev, id])
  }

  const paySelected = () => {
    const payload = {ids: selectedIds}
    setLoading(true)
    axios.post('/api/air/airBooking/tiedUpTickets/toggleMany',payload)
      .then(()=>{
        loadInfo(getValues())
      })
      .finally(setLoading.bind(false))
    console.log(payload)
  }

  useEffect(() => {
    axios.post('/api/users/emplSearch', {operatorOneS: true})
      .then(({data})=>{
        const newArr = data.data.map(user=>{
          return {label: user.label, value: user.value._id}
        })
        setEmplArray([{label:"Все", value:null}, ...newArr])
      })
  }, []);
  const persons = data && _.groupBy(data, 'issuedBy')
  const unpaid = (data || []).filter(item => !item.paid)
  return (
    <>
      <Helmet>
        <title>Подвязки по билетам</title>
      </Helmet>
      <Tabs
        variant="underline"
        activeKey={pageTab}
        onSelect={setPageTab}
        className={'mb-3'}
      >
      <Tab eventKey="ties" title="Подвязки">
      <BlockUi blocking={loading}>
      <Portlet className={'mb-1'}>
        <PortletHeader title={'Привязки на билетах'} toolbar={<PortletHeaderToolbar>
          <form onSubmit={handleSubmit(onSubmit)} className={'d-flex align-items-center gap-2'}>
            <CustomDatePicker formController={formController}
                              label={"Дата c"}
                              value={defaultVal.start}
                              name={`start`}
                              rules={{required: true}}/>
            <CustomDatePicker formController={formController}
                              label={"Дата по"}
                              value={defaultVal.end}
                              name={`end`}
                              rules={{required: true}}/>
            <FormHookSelect
              defaultValue={defaultVal.sortField}
              register={register(`sortField`, { required: true })}
              errors={errors}
              label={'Сортировка'}
            >
              {sortingFields.map(u=>{
                return <option value={u.value}>{u.label}</option>
              })}
            </FormHookSelect>
            <SearchSelect
              style={{width:"10rem"}}
              onChange={statusOnChange}
              defaultValue={statusValue}
              hasError={_.get(errors, "status")}
              label={'Статус'}
              array={status}/>
            {emplArray && <SearchSelect
              style={{width:"12rem"}}
              onChange={issuedByOnChange}
              defaultValue={issuedByValue}
              hasError={_.get(errors, "issuedBy")}
              label={'Выписал'}
              array={emplArray}/>}
            {/*<Form.Label className={'d-flex align-items-center gap-2'}>*/}
            {/*  <input*/}
            {/*    defaultChecked={defaultVal.needToCheck}*/}
            {/*    {...register(`needToCheck`)}*/}
            {/*    type={"checkbox"}*/}
            {/*  />{" "}*/}
            {/* Только <br/>требующие проверки*/}
            {/*</Form.Label>*/}
            <LoadingButton loading={loading} title={'Получить'}/>
          </form>
        </PortletHeaderToolbar>}/>
      </Portlet>
        {data && <Tabs
          variant="underline"
          id="controlled-tab-example"
          activeKey={tabIndex}
          onSelect={key => {
            setTabIndex(key)
            window.location.hash = key
          }}
        >
          <Tab eventKey="list" title="Список">
            <Portlet>
              <PortletBody>
                <Table bordered size={'sm'}>
                  <thead>
                  <tr>
                    <th></th>
                    <th>Выписал</th>
                    <th>Билет</th>
                    <th>Комментарий</th>
                    <th>Дата выписки</th>
                    <th>Отлетает (по времени Алматы)</th>
                    <th>Сумма Крс</th>
                    <th>Вознаграждение</th>
                    <th>Оплачен</th>
                    <th>
                      <input
                        type={"checkbox"}
                        checked={!!unpaid.length && unpaid.every(item => selectedIds.includes(item.id))}
                        onChange={(e) => setSelectedIds(e.target.checked ? unpaid.map(item => item.id) : [])}
                      />
                    </th>
                    <th>Надо проверить</th>
                  </tr>
                  </thead>
                  <tbody>
                  {data.map((item, index) => {
                    const needCheck = typeof item.checked === 'boolean' && !item.checked
                    let legend = {
                      color: 'red',
                      text:'Уже отлетал, но не оплачен'
                    }
                    if (item.paid) {
                      legend = {
                        color: 'green',
                        text:'Оплачен'
                      }
                    } else if (!item.paid && !item.flown) {
                      legend = {
                        color: 'green',
                        text:'Еще не отлетал и не оплачен'
                      }
                    }
                    return <tr key={index}
                               style={{backgroundColor: needCheck ? 'rgba(255,71,71,0.35)' : "white"}}>
                      <td>
                        <Tooltip content={legend.text} direction="right">
                          <i className="fa fa-circle" style={{color: legend.color}}/>
                        </Tooltip>
                      </td>
                      <td>{item.issuedBy}</td>
                      <td style={{textWrap: 'nowrap'}}>
                        <Link to={item.baseLink+'/'+item.bookingId} target={'_blank'}>
                          {item.ticketNumber}
                        </Link>
                      </td>
                      <td style={{maxWidth: '25rem'}}>{item.comment}</td>
                      <td>{item.issueDate.slice(0, 10)}</td>
                      <td>{item.lastFlightDate}</td>
                      <td>{numberFormat(item.krs)}</td>
                      <td>{numberFormat(item.reward)}</td>
                      <td>
                        {item.paid && `${item?.paidAt || ''} ${item.paidBy || ''}`}
                        <div className={'pointer text-decoration-underline'}
                             onClick={() => clickToggle('tiedUpPaid', item.id)}>
                          {item.paid ? 'Отменить' : 'Оплатить'}
                        </div>
                      </td>
                      <td>
                        {!item.paid && <Form.Label className={'d-flex align-items-center gap-2 mb-0'}>
                          <input
                            type={"checkbox"}
                            checked={selectedIds.includes(item.id)}
                            onChange={() => toggleSelected(item.id)}
                          />
                        </Form.Label>}
                      </td>
                      <td>
                        <div className={'pointer text-decoration-underline'}
                             onClick={() => clickToggle('tiedUpChecked', item.id)}>
                          {needCheck ? 'Отметить проверенным' : item.checked ? 'Отмена проверки' : ''}
                        </div>
                      </td>
                    </tr>
                  })}
                  <tr>
                    <th colSpan={7}>Итого</th>
                    <th colSpan={4}>{numberFormat(_.sumBy(data, 'reward'))}</th>
                  </tr>
                  </tbody>
                </Table>
                <LoadingButton
                  type={"button"}
                  title={'Оплатить выделенные'}
                  disabled={!selectedIds.length}
                  onClick={paySelected}
                />
              </PortletBody>
            </Portlet>
          </Tab>
          <Tab eventKey="total" title="Всего">
            <Portlet>
              <PortletBody>
                <Table bordered size={'sx'}>
                  <thead>
                  <tr>
                    <th>Агент</th>
                    <th>Билетов</th>
                    <th>Уже выплачено</th>
                    <th>Еще не выплачено</th>
                    <th>Сумма под вопросом</th>
                  </tr>
                  </thead>
                  <tbody>
                  {persons && Object.keys(persons).map((key, index) => {
                    return <tr key={index}>
                      <td>{key}</td>
                      <td>{numberFormat(persons[key].length)}</td>
                      <td>{numberFormat(_.sumBy(persons[key], (item) => item.paid ? item.reward : 0))}</td>
                      <td>{numberFormat(_.sumBy(persons[key], (item) => !item.paid ? item.reward : 0))}</td>
                      <td>{numberFormat(_.sumBy(persons[key], (item) => typeof item.checked === 'boolean' && !item.checked ? item.reward : 0))}</td>
                    </tr>
                  })}
                  </tbody>
                </Table>

              </PortletBody>
            </Portlet>
          </Tab>
        </Tabs>}
      </BlockUi>
      </Tab>
      <Tab eventKey="payments" title="Инфо по оплатам">
        <TiedUpPaymentsInfo/>
      </Tab>
      </Tabs>

    </>
  );
};

export default TiedUpList;
